/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductionInfoUpdate,
    ProductionInfoUpdateFromJSON,
    ProductionInfoUpdateFromJSONTyped,
    ProductionInfoUpdateToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProductionSetUpdate
 */
export interface ProductionSetUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProductionSetUpdate
     */
    batesNumberPrefix: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionSetUpdate
     */
    batesNumberStart: number;
    /**
     * 
     * @type {ProductionInfoUpdate}
     * @memberof ProductionSetUpdate
     */
    productionInfo?: ProductionInfoUpdate;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionSetUpdate
     */
    isArchived?: boolean;
}

export function ProductionSetUpdateFromJSON(json: any): ProductionSetUpdate {
    return ProductionSetUpdateFromJSONTyped(json, false);
}

export function ProductionSetUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionSetUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batesNumberPrefix': json['batesNumberPrefix'],
        'batesNumberStart': json['batesNumberStart'],
        'productionInfo': !exists(json, 'productionInfo') ? undefined : ProductionInfoUpdateFromJSON(json['productionInfo']),
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
    };
}

export function ProductionSetUpdateToJSON(value?: ProductionSetUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batesNumberPrefix': value.batesNumberPrefix,
        'batesNumberStart': value.batesNumberStart,
        'productionInfo': ProductionInfoUpdateToJSON(value.productionInfo),
        'isArchived': value.isArchived,
    };
}


